// extracted by mini-css-extract-plugin
module.exports = {"list":"DataList_list__1EjX_","horizontal":"DataList_horizontal__-2Rc8","vertical":"DataList_vertical__3fLYB","title":"DataList_title__2yWPl"};